import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Col, Row, ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import {HiOutlineViewList} from "react-icons/hi";

function getNewsletter() {

    return fetch('https://backapi.therunningcollective.fr/api/protected/newsletter/clients', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class NewsletterPageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientsNewsletteer: null,
        }

    }

    async componentDidMount() {
        await getNewsletter().then(data => {
            const uniqueNames = data
                .map(e => e['email'])

                // store the keys of the unique objects
                .map((e, i, final) => final.indexOf(e) === i && i)

                // eliminate the dead keys & store unique objects
                .filter(e => data[e]).map(e => data[e]);
            this.setState({clientsNewsletteer: uniqueNames})
        }).catch(err =>
            this.setState({errors: "error while getting clientsNewsletteer"})
        );
    };

    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={1} className="products-buttons">
                        <ToggleButtonGroup value={this.state.mode} type="checkbox">
                            <ToggleButton
                                key={2}
                                type="radio"
                                variant="secondary"
                                name="radio"
                                value={"Liste"}
                                onChange={(e) => this.setState({mode: e.currentTarget.value})}
                            >
                                <HiOutlineViewList/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                { this.state.errors != null ? <p>"Erreur lors de la récupération des clients, veuillez vous reconnecter"</p> : null}

                { (!this.state.clientsNewsletteer && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Email</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.clientsNewsletteer.map(client => (
                            <tr
                                key={client.email}
                                id={client.email}
                            >
                                <td>{client.email} </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
            </div>
        );

    }
}